import { useContext } from 'react';

import { DeviceContext } from '@components/layout/device-provider';

/** Returns `true` when viewport width < 768px (Tailwind `md` breakpoint). */
export function useIsMobile() {
  return useContext(DeviceContext).isMobile;
}
